var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormatFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-3h24v24H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.778 11.25s-2.222 3.257-2.222 4.5c0 1.242.995 2.25 2.222 2.25C19.005 18 20 16.992 20 15.75c0-1.243-2.222-4.5-2.222-4.5zm-.326-3.62l-7.21-7.3a1.102 1.102 0 00-1.572 0L5.643 3.394 2.453.165a.55.55 0 00-.786 0l-.393.397a.567.567 0 000 .796l3.19 3.23L.976 8.12a3.404 3.404 0 000 4.773l4.07 4.12a3.302 3.302 0 004.712 0l7.694-7.79a1.135 1.135 0 000-1.591zM8.58 15.819a1.645 1.645 0 01-1.178.494c-.445 0-.863-.175-1.178-.494l-3.956-4.006h10.269L8.58 15.818zm5.624-5.693H1.714a1.68 1.68 0 01.44-.813l3.489-3.531L8.07 8.238c.325.33.852.33 1.178 0a.851.851 0 000-1.193L6.821 4.588 9.455 1.92l6.426 6.505-1.677 1.699z",
    fill: "#151A30"
  }))));
}

export default SvgFormatFill;